<template>

	<!DOCTYPE html>
	<html lang="ko">
	<head>
		<meta charset="UTF-8">
		<meta http-equiv="X-UA-Compatible" content="IE=edge">
		<meta name="viewport" content="width=device-width, initial-scale=1.0">
		<title>상상플렉스 - 고객사</title>
		<link rel="preload" as="style" href="/ssflex_cs1/assets/css/style.css" onload="this.onload=null;this.rel='stylesheet'">
	</head>
	<body>
	<div id="wrap">

		<div id="app">

			<cs1-header v-if="isLayout"></cs1-header>

				<router-view name="rv-app" :key="$route.fullPath"></router-view>

			<cs1-footer v-if="isLayout"></cs1-footer>

		</div>


	</div>
	</body>

	<progress-bars></progress-bars>

	</html>

</template>

<script>
import Cs1Header from "@/cs1/components/layouts/cs1Header";
import Cs1Footer from "@/cs1/components/layouts/cs1Footer";
import ProgressBars from "@/commons/progressBars";

/*var resource = document.createElement('link');
resource.setAttribute("rel", "stylesheet");
resource.setAttribute("href","/ssflex_cs1/assets/css/style.css");
resource.setAttribute("type","text/css");
var head = document.getElementsByTagName('head')[0];
head.appendChild(resource);*/

export default {
	name: "App",
	components: {ProgressBars, Cs1Header, Cs1Footer},
	data () {

		let isLayout = false
		if ( this.webUtils.getParameter("isLayout") !== 'false' ) {
			isLayout = true;
		}

		return {
			isLayout,
		}
	},
	created() {
		this.init()
	},
	mounted() {

		this.init()
	},
	methods: {


		async init () {

			var self = this

			try {
				self.coInfoVO = await self.getCoInfoVO()
				if (self.coInfoVO.logo == null) {
					self.coInfoVO.logo = "/assets/img/temp/temp_logo.svg";
				}

				/**
				 * 포인트 컬러 css 적용
				 * @type {HTMLLinkElement}
				 */
				let style = document.createElement('link');
				style.type = "text/css";
				style.rel = "stylesheet";
				style.href = APIs.CSS_URL + "/attach_files/company/" + self.coInfoVO.coCode + "/pointerColor.css";
				document.head.appendChild(style);

				// 아이폰이 경우 사이트 설정 따라가게 설정
				if (self.appDevice() === "IOS") {
					self.isShowShopping = self.coInfoVO.isIosShop
					self.isShowSnsLogin = self.coInfoVO.isIosSns
				}
			} catch (e) {}
		}

	}
}
</script>

<style scoped>
/*@import "/ssflex_cs1/assets/css/style.css";*/

.fade-enter-active,
.fade-leave-active {
	transition-duration: 0.3s;
	transition-property: opacity;
	transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0
}

</style>
